module.exports = __webpack_public_path__ + "img/upload-image.c3f02b20.svg";